import { useEditor, useEditorStore } from '@craftjs/core';

import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import { Box, IconButton } from '@mui/material';
import TedTheme from '@common/providers/ThemeProvider/TedTheme';

const UndoRedoButtons = () => {
  const { actions, canUndo, canRedo } = useEditor((state, query) => {
    return {
      canUndo: query?.history?.canUndo(),
      canRedo: query?.history?.canRedo(),
    };
  });

  return (
    <TedTheme>
      <Box
        sx={{
          display: 'flex',
          height: 35,
        }}
      >
        <IconButton onClick={() => actions.history.undo()} size='small'>
          <UndoIcon color={canUndo ? 'primary' : 'secondary'} />
        </IconButton>
        <IconButton onClick={() => actions.history.redo()} size='small'>
          <RedoIcon color={canRedo ? 'primary' : 'secondary'} />
        </IconButton>
      </Box>
    </TedTheme>
  );
};

export default UndoRedoButtons;
